<template>
  <div>
    <h1 class="title has-text-centered">ช่องทางการชำระเงิน</h1>
    <div class="columns">
      <div class="column card" v-for="account in dataAccounts" :key="account.type">
        <div class="card-image">
          <figure class="image is-5 image-centered">
            <img :src="account.image">
          </figure>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-content has-text-centered">
              <p class="title is-4">หมายเลขบัญชี</p>
              <p class="subtitle is-6">{{ account.account }}</p>
              <br>
              <p class="title is-4">ชื่อบัญชี</p>
              <p class="subtitle is-6">{{ account.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accounts: {
      type: Array,
      default () {
        return [
          {
            account: '631-2-118376',
            image: 'https://kasikornbank.com/SiteCollectionDocuments/about/img/logo/master-brand.png',
            name: 'พงศกร อ่อนศรี',
            type: 'ธนาคารกสิกร'
          },
          {
            account: '087-565-6957',
            image: 'https://image.makewebeasy.net/makeweb/0/cI3KWoTJY/00_LOGO/PROMTPAY_UNIPAKCENTER_BLOCK.jpg',
            name: 'พงศกร อ่อนศรี',
            type: 'บัญชีพร้อมเพย์'
          },
          {
            account: '087-565-6957',
            image: 'http://www.9tana.com/wp-content/uploads/2016/03/truewallet-600x290.jpg',
            name: 'พงศกร อ่อนศรี',
            type: 'หมายเลขทรูมันนี่'
          }
        ]
      }
    }
  },
  data () {
    return {
      dataAccounts: this.accounts
    }
  }
}
</script>

<style lang="scss">

</style>
